import gql from "graphql-tag";

const GET_USER_ROLES_ASSIGNMENT = gql`
  query ($affiliate: String, $filter: BaseFilter) {
    getUserRoleAssignmentPage(affiliate: $affiliate, filter: $filter) {
      data {
        id
        affiliate
        firstName
        lastName
        email
        roles
        responsibilities
        site
        discipline
      }
      totalPages
      currentPage
      totalItems
    }
  }
`;

export { GET_USER_ROLES_ASSIGNMENT };
